import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Carousel, CarouselItem } from "react-bootstrap";
import axios from "axios";
// import { css } from "@emotion/core";
import "../css/testimonials.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import images
import rating from '../img/testimonial/Stars.png';


function Testimonials(props) {
    const [surveyData, setSurveyData] = useState("");
    const [loading, setLoading] = useState(false);
    const [genericReviews, setGenericReviews] = useState(false);
    let Reviews = ""


    useEffect(() => {
        setLoading(true)

        axios.post(process.env.REACT_APP_SURVEY_API, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                setLoading(false)

                if (response.data && Array.isArray(response.data)) {
                    setSurveyData(response.data)
                    setGenericReviews(false);
                } else {
                    setSurveyData(null)
                    setGenericReviews(true);
                }
            })
            .catch(() => {
                setLoading(false)

                setSurveyData(null)
                setGenericReviews(true);
            })

    }, [])

    if (surveyData) {
        Reviews= surveyData.map(review => <CarouselItem key={review.id}
            className="testim_carouselItem">
            <Carousel.Caption className="testim_caption">
                <h4 className="pb-3 reviewer_comment">{review.review}</h4>
                {/* <Image src={greyLine} fluid alt="Grey line" /> */}
                <h5 className="text-center reviewer_name">{review.customer_first_name} {review.customer_last_name}</h5>
            </Carousel.Caption>
        </CarouselItem>)
    } 


    return (
        <div className="testimonial-wrapper">
            <Container className="what_people_say text-center d-flex justify-content-center" fluid>
                <Row>
                    <Col className="py-1">
                        <h3>What Home Buyers Are Saying</h3>
                    </Col>
                </Row>
            </Container>

            {surveyData && !loading && !genericReviews ? <Container fluid className="pb-2 pb-md-5">
                <Row className="testimonials-row justify-content-center">
                    {Array.isArray(surveyData) && <Col sm={12}>
                        <Carousel interval={6000}>
                            {Reviews}
                        </Carousel>
                    </Col>}
                </Row>
            </Container> : null}

            {genericReviews && !loading ? <Container fluid className="pb-2 pb-md-5 iframe-review-container fallback-reviews">
                <Row>
                    <Col lg={12} className="d-flex justify-content-center align-items-center text-center py-3">
                        <h3 style={{ verticalAlign: "middle" }}><Image fluid src={rating} alt="rating stars" style={{ width: "50%" }} /> 1800+&nbsp;reviews</h3>
                    </Col>
                </Row>
                <Row className="testimonials-row justify-content-center">
                    <Col lg={4} className="text-center widgetWrapper">
                        <script type="text/javascript" src="https://birdeye.com/embed/v4/154827373198858/8/1234567985183"></script>

                        <div id="bf-revz-widget-1234567985183" style={{ WebkitOverflowScrolling: 'touch' }} className="responsive-iframe">
                            <iframe className="taca-app-generic-review-iframe" name="bfiframe" src="https://birdeye.com/widget/render.php?bid=154827373198858&wid=8&ver=4&update=0" id="bfpublish" scrolling="no" frameBorder={0} title="Customer reviews"
                                style={{ 
                                    borderWidth: '0px', display: 'block', margin: '0px auto', overflow: 'hidden', width: '270px'
                                }}
                            />

                            <div className="bf-dv d-none"><span className="bf-spn"> powered by <a className="bf-pwr" href="https://birdeye.com?utm_source=SRC&utm_medium=widget_review-feed&utm_campaign=birdeye_widget&utm_term=powered-by-birdeye&utm_content=rotating-widget_#51a8d3" rel="noopener noreferrer" target="_blank">BirdEye</a></span></div></div>
                    </Col>
                </Row>
            </Container> : null}
        </div>
    )
}

export default Testimonials;